import IPermissionService from 'services/permission/IPermissionService';
import { USER_ROLE } from 'typings/models/user.enum';
import { TENANT_TYPE } from 'typings/subEntities/tenant.enum';

export default class EnterpriseUtils {
  public static getPermissionConfigs = (enterprise: Enterprise, currentUser: User): IPermissionService.PermissionConfigs => {
    return {
      canCreateCustomServices:
        currentUser.roles.includes(USER_ROLE.orderManager) &&
        [TENANT_TYPE.enterprise, TENANT_TYPE.platformOperator].includes(currentUser.type)
          ? enterprise.clientPricelistSettings.allowAddCustomServices
          : enterprise.technicianPricelistSettings.allowAddCustomServices,
      geoPointForServerActions:
        currentUser.roles.includes(USER_ROLE.orderTechnician) &&
        [TENANT_TYPE.enterprise, TENANT_TYPE.platformOperator].includes(currentUser.type)
          ? enterprise.settings.technician.geoPositionTrackingType
          : undefined,
      orderFieldVisitbility: enterprise.settings.order.fieldVisibilitySettings.configMap[currentUser.position.technicalName],
      orderFieldUpdateConfig: enterprise.settings.order.fieldUpdateSettings?.configMap[currentUser.position.technicalName],
    };
  };

  public static isEntityInherited = (currentUser: User | null, entity: EntityWithTenant): boolean => {
    return currentUser?.tenant.id !== entity.tenant.id;
  };

  public static getEntityOwnerName = (currentUser: User | null, entity: EntityWithTenant): string => {
    const isInherited = this.isEntityInherited(currentUser, entity);
    return isInherited ? entity.tenant.name : '';
  };
}
